import React from 'react';
import {
  Text,
  View,
  StyleSheet,
  ImageBackground,
  TextInput,
} from 'react-native';
import { Button } from '../../components';
import TriffMeal from '../../assets/images/triff-meal.jpg';
import { SHADOWS } from '../../settings/shadows';
import { geocodeLocation } from '../../utilities/location';
import { useHistory } from 'react-router-dom';
import { isRowLayout } from '../../utilities/screen';

const styles = StyleSheet.create({
  container: {
    backgroundColor: 'grey',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    padding: 10,
    paddingVertical: isRowLayout ? 200 : 50,
    minHeight: isRowLayout ? undefined : '90vh',
  },
  title: {
    fontSize: 50,
    fontWeight: 'bold',
    color: 'white',
    maxWidth: 800,
    textAlign: 'center',
    margin: 20,
    ...SHADOWS.text,
  },
  input: {
    backgroundColor: 'white',
    padding: 15,
    border: 'grey',
    borderRadius: 5,
    justifyContent: 'center',
    margin: isRowLayout ? 0 : 10,
    fontSize: 'large',
  },
});

function Stage() {
  const [searchText, setSearchText] = React.useState('');
  const history = useHistory();
  return (
    <ImageBackground style={styles.container} source={TriffMeal}>
      <Text style={styles.title}>
        Finde Treffen und Aktivitäten in deiner Nähe.
      </Text>
      <View
        style={{
          flexDirection: isRowLayout ? 'row' : 'column',
          justifyContent: 'center',
          alignItems: isRowLayout ? 'center' : 'stretch',
          backgroundColor: isRowLayout ? 'white' : undefined,
          borderRadius: isRowLayout ? 50 : undefined,
          padding: isRowLayout ? 10 : undefined,
        }}
      >
        <View>
          <TextInput
            style={styles.input}
            placeholder={'Ort eingeben'}
            onChangeText={text => setSearchText(text)}
            value={searchText}
          />
        </View>
        <Button
          text={'Suchen'}
          size="large"
          action={async () => {
            if (searchText.length > 0) {
              const region = await geocodeLocation(searchText);
              // The Geocode API does not always return a region.
              if (region) {
                return history.push('/discover', { region });
              }
              return history.push('/discover');
            }
            return history.push('/discover');
          }}
        />
      </View>
    </ImageBackground>
  );
}

export default Stage;
